import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Badge } from "antd"
import dayjs from "dayjs"

//------------------------------------------------------------------------------

function TicketPreview(props) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const {
    id,
    description,
    subject,
    updatedAt,
    onClick,
    unreadedMessages,
  } = props

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  function handleClick() {
    onClick && onClick(id)
  }

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const formattedUpdatedAt = dayjs(updatedAt).format("DD MMM")

  return (
    <div className={props.className} onClick={handleClick}>
      <div className="row">
        <h3>{subject}</h3>

        <span className="updated-date">{formattedUpdatedAt}</span>
      </div>

      <div className="row">
        <p className="truncated-text">
          {description}
        </p>

        {unreadedMessages > 0 && <Badge count={unreadedMessages} />}
      </div>
    </div>
  )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

TicketPreview.propTypes = {
  className: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  subject: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  updatedAt: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
  unreadedMessages: PropTypes.number,
}

TicketPreview.defaultProps = {
  onClick: null,
  unreadedMessages: 0,
}

// ----------------------------------------------------------------------------

const StyledTicketPreview = styled(TicketPreview)`
  & {
    display: flex;
    flex-direction: column;

    box-sizing: border-box;
    padding: 20px 20px;

    width: 100%;
    max-width: 400px;

    height: 120px;
    max-height: 120px;

    border-radius: 4px;

    background-color: ${(props) =>
    props?.selected
      ? props?.theme?.colors?.hoverPrimaryColor
      : props?.theme?.colors?.secondaryBackgroundColor};
    box-shadow: ${(props) =>
    props?.selected
      ? props?.theme?.shadows?.insetCardBoxShadow
      : props?.theme?.shadows?.cardBoxShadow};

    cursor: pointer;
    transform-origin: center center;
    transition: all 0.2s ease-in-out;

    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      h3 {
        margin-bottom: 0;
        font-weight: bold;
      }

      .updated-date {
        font-size: 12px;
        font-weight: 500;
        color: ${(props) => props?.theme?.colors?.textSecondaryColor};
      }

      p {
        width: 100%;
        margin-bottom: 0;
        overflow: hidden;
      }
      
      .truncated-text {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    :hover {
      background-color: ${(props) => props?.theme?.colors?.hoverPrimaryColor};
    }

    :active {
      transform: scale(0.98);
      box-shadow: ${(props) => props?.theme?.shadows?.insetCardBoxShadow};
    }
  }
`
// ----------------------------------------------------------------------------

export default StyledTicketPreview
